import { useEffect, useState } from 'react';

// ── useMediaQuery — reactive breakpoint match (SSR-safe) ─────────────────────
// Used by the Notification Center to drive the two-pane (≥1024px reading pane)
// vs Sheet (<1024px) split: the SAME selection state renders either surface.
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange(); // sync in case the query changed between render and effect
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
